import React from 'react'
import Show from 'services/Show';
import { formatDate } from 'services/utils'
import './show_certificate.sass';
import { Spinner } from 'components/atoms';
import PrinterSelect from 'components/PrinterSelect';
import PrintButton from 'components/PrintButton';

export default class ShowCertificates extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      show: {},
      dogs: [],
      catNum: 1,
      copies: 1,
      maxNumber: 1,
      showOwner: false,
      showId: match.params.id,
    }
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.loadData();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  loadData = () => {
    this.setState({loading: true});
    Show.getCertificates(this.state.showId).then(({show, dogs}) => {
      if (this.mounted) {
        const maxNumber = dogs[dogs.length-1].catalog_number;
        this.setState({ show: new Show(show), dogs, maxNumber });
      }
    }).catch(alert).then(() => {
      if (this.mounted) {
        this.setState({loading: false});
      }
    });
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  catNumChanged = ({target:{value}}) => {
    let catNum = value;
    this.setState({ catNum });
  }

  copiesChanged = ({target:{value}}) => {
    let copies = +value;
    this.setState({ copies });
  }

  renderCertificates() {
    const {catNum, copies, dogs, show, showOwner} = this.state;
    if (!dogs) return null;
    let certificates = [];
    let catNumInt = parseInt(catNum);
    if (!catNumInt) return null;
    const dog = dogs.find(dog => dog.catalog_number === catNumInt);
    if (!dog || !copies) return null;
    for(let i=0; i<copies; i++) {
      certificates.push(<Certificate key={i} dog={dog} show={show} showOwner={showOwner} />)
    }
    return certificates;
  }

  showOwnerChanged = ({target}) => {
    const showOwner = target.checked
    this.setState({ showOwner });
  }

  render() {
    const {catNum, copies, showOwner, maxNumber, show, loading} = this.state;
    let showInfo = null;
    if (show) {
      showInfo = (
        <span className="show">
          <span className="show-date"> {formatDate(show.starts_at)} </span>
          <i> / </i>
          <strong className="show-name"> {show.name} </strong>
        </span>
      )
    }

    if (!show || loading) {
      return (
        <div className="container-fluid">
          <h4>Сертификаты собаке выставки - {showInfo}</h4>
          {loading && <Spinner /> }
        </div>
      )
    }
    const certificates = this.renderCertificates();

    return (
      <div className="container-fluid">
        <div className="no-print">
          <h4>Сертификаты собаке выставки - {showInfo}</h4>

          <div className="row">
            <div className="col-md-2">
              <label>Номер по каталогу</label>
              <input id="catNum" type="number" name="catNum" className="form-control" 
                value={catNum} min="1" max={maxNumber} onChange={this.catNumChanged} />
            </div>
            <div className="col-2">
              <label>Кол-во копий</label>
              <input id="copies" type="number" name="copies" className="form-control" 
                value={copies} min="1" max="100" onChange={this.copiesChanged} />
            </div>
            <div className="col-2">
              <label>Принтер</label>
              <PrinterSelect className="form-select" orientation="landscape"/>
            </div>
            <div className="col-1">
              <label className="row">&nbsp;</label>
              <PrintButton disabled={!certificates} />
            </div>
            <div className="col-2">
              <label>Владелец</label>
              <div className="custom-control custom-switch">
                <input type="checkbox" name="showOwner" checked={showOwner} onChange={this.showOwnerChanged} 
                  className="custom-control-input" id="closedSwitch" />
                <label className="custom-control-label" htmlFor="closedSwitch">{showOwner ? 'Печатать' : 'Скрыть'}</label>
              </div>
            </div>
          </div>
        </div>

        <div id="certificates">
          {certificates}
        </div>
      
      </div>
    );
  }
}

function Certificate({show, dog, showOwner}) {
  return (
    <div id={`certificate-${dog.id}`} className="certificate print-page">
      <div className="dog-catalog-number">{dog.catalog_number}</div>
      <div className="dog-name">{dog.name}</div>
      <div className="dog-breed-ru">{dog.breed_name}</div>
      <div className="dog-breed-lat">{dog.breed_name_lat}</div>
      <div className="dog-pedigree">{dog.pedigree}</div>
      <div className="dog-owner">{showOwner ? dog.owner_name : ''}</div>
      <div className="dog-printdate">{formatDate(new Date(), 'dd.MM.yyyy')}</div>
    </div>
  );
}